import { render, staticRenderFns } from "./ChatLanding.vue?vue&type=template&id=6b90c576&scoped=true&"
import script from "./ChatLanding.vue?vue&type=script&lang=js&"
export * from "./ChatLanding.vue?vue&type=script&lang=js&"
import style0 from "./ChatLanding.vue?vue&type=style&index=0&id=6b90c576&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b90c576",
  null
  
)

export default component.exports